import UnderConstruction from '../components/UnderConstruction';

function Analytics(props){
    return(
        <UnderConstruction/>
    )
}

export default Analytics;